
// 详情基本信息
export const detailBaseInfoOption = function () {
  return [
    {
      prop: 'beginTime',
      label: '内保起期',
    },
    {
      prop: 'endTime',
      label: '内保止期',
    },
    {
      prop: 'days',
      label: '内保天数',
    },
    {
      prop: 'orgName',
      label: '出单公司',
    },
    {
      prop: 'saleName',
      label: '业务员',
    },
    {
      prop: 'payType',
      label: '缴费方式',
    },
    {
      prop: 'handlerName',
      label: '经办人',
    },
    {
      prop: 'creatorName',
      label: '制单人',
    },
    {
      prop: 'remark',
      label: '备注'
    }
  ]
}

export default {}